import {prop} from "../../decorators/property";

export class BaseRelationModel extends Backbone.AssociatedModel {

    @prop() public Id: string;
    @prop() public DocumentType: DocumentType;
    @prop() public Title: string;
    @prop() public FilteredOut: boolean;
    @prop() public IsHiddenJurisdiction: boolean;
    @prop() public ForceShow: boolean;
    @prop() public Year: number;
    @prop() public Heading: string;
    @prop() public SubHeading: string;
    @prop() public IconUrl: string;
    @prop() public AlwaysShowTreatmentHeadings: boolean;
    @prop() public SemiCollapsed: boolean;

    public get IsActuallyVisible() {
        return !this.FilteredOut;
    }
    public get FilterableText(): string {
        return "" + this.Title + this.Year;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/base-relation.ts